const FINISH_EVENTS = new Set(["FINISH", "FINISH_WHATSAPP_BUSINESS_APP_ONBOARDING"]);
const metaId = (value) => /^\d+$/.test(String(value || "")) ? String(value) : "";
let sdkPromise;
let signupInProgress = false;
export const isMetaSdkReady = () => typeof window !== "undefined" &&
  Boolean(window.FB?.login && window.FB?.init && !window.FB.__buffer);

export const readEmbeddedSignupEvent = (value) => {
  let payload = value;
  if (typeof payload === "string") {
    try { payload = JSON.parse(payload); } catch { return null; }
  }
  if (!payload || payload.type !== "WA_EMBEDDED_SIGNUP") return null;
  const event = String(payload.event || "").toUpperCase();
  if (FINISH_EVENTS.has(event)) {
    const wabaId = metaId(payload.data?.waba_id);
    const phoneNumberId = metaId(payload.data?.phone_number_id);
    if (!wabaId || (event === "FINISH" && !phoneNumberId)) return null;
    return { type: "finish", finishEvent: event, wabaId, phoneNumberId };
  }
  return event === "CANCEL" || event === "ERROR" ? { type: "cancel" } : null;
};

export const loadMetaSdk = () => {
  if (typeof window === "undefined") return Promise.reject(new Error("Este navegador no permite conectar WhatsApp."));
  if (isMetaSdkReady()) return Promise.resolve(window.FB);
  if (sdkPromise) return sdkPromise;
  sdkPromise = new Promise((resolve, reject) => {
    let script = document.getElementById("mozzo-meta-sdk");
    let settled = false;
    const previousAsyncInit = window.fbAsyncInit;
    const finish = (message) => {
      if (settled) return;
      settled = true;
      window.clearTimeout(timer);
      window.clearInterval(poll);
      script.removeEventListener("load", onLoad);
      script.removeEventListener("error", onError);
      document.removeEventListener("securitypolicyviolation", onPolicyViolation);
      if (window.fbAsyncInit === onAsyncInit) window.fbAsyncInit = previousAsyncInit;
      if (!message) resolve(window.FB);
      else {
        script.remove();
        if (window.FB?.__buffer) delete window.FB;
        reject(new Error(message));
      }
    };
    const onLoad = () => { if (isMetaSdkReady()) finish(); };
    const onError = () => finish("No se pudo cargar Meta. Revisa tu conexion o los bloqueadores del navegador y reintenta.");
    const onAsyncInit = () => {
      try { if (typeof previousAsyncInit === "function") previousAsyncInit(); }
      finally { onLoad(); }
    };
    const onPolicyViolation = (event) => {
      if (String(event.effectiveDirective || "").startsWith("script-src") &&
        /^https:\/\/connect\.facebook\.net(?:\/|$)/.test(event.blockedURI || "")) {
        finish("La seguridad de esta pagina bloqueo Meta. Recarga la pagina; si continua, avisa a soporte.");
      }
    };
    const timer = window.setTimeout(() => finish("Meta no termino de cargar. Revisa tu conexion y reintenta."), 15000);
    // sdk.js first exposes a buffered stub, then downloads the actual SDK.
    const poll = window.setInterval(onLoad, 100);
    window.fbAsyncInit = onAsyncInit;
    document.addEventListener("securitypolicyviolation", onPolicyViolation);
    const needsAppend = !script;
    if (!script) {
      script = document.createElement("script");
      script.id = "mozzo-meta-sdk";
      script.async = true;
      script.src = "https://connect.facebook.net/es_LA/sdk.js";
    }
    script.addEventListener("load", onLoad);
    script.addEventListener("error", onError);
    if (needsAppend) document.head.appendChild(script);
    onLoad();
  }).finally(() => { sdkPromise = null; });
  return sdkPromise;
};

// The SDK is preloaded so FB.login keeps the original click gesture on Safari.
export const openWhatsAppEmbeddedSignup = ({ appId, configId, graphVersion, phone }) => {
  const facebook = window.FB;
  if (!isMetaSdkReady()) {
    return Promise.reject(new Error("Meta no esta listo. Usa Reintentar carga de Meta antes de vincular el numero."));
  }
  if (signupInProgress) return Promise.reject(new Error("Ya hay una conexion de WhatsApp abierta."));
  signupInProgress = true;
  return new Promise((resolve, reject) => {
    let code = "";
    let signup = null;
    let settled = false;
    const cleanup = () => {
      settled = true;
      signupInProgress = false;
      window.clearTimeout(timer);
      window.removeEventListener("message", handleMessage);
    };
    const fail = (message) => {
      if (settled) return;
      cleanup();
      reject(new Error(message));
    };
    const finish = () => {
      if (settled || !code || !signup) return;
      cleanup();
      resolve({ code, wabaId: signup.wabaId, phoneNumberId: signup.phoneNumberId, finishEvent: signup.finishEvent });
    };
    const handleMessage = (event) => {
      if (!["https://www.facebook.com", "https://web.facebook.com"].includes(event.origin)) return;
      const parsed = readEmbeddedSignupEvent(event.data);
      if (!parsed) return;
      if (parsed.type === "cancel") {
        fail("La conexion fue cancelada o Meta no pudo completarla. No se guardo un nuevo numero en Mozzo.");
        return;
      }
      signup = parsed;
      finish();
    };
    const timer = window.setTimeout(() => fail("La conexion de WhatsApp tardo demasiado. Vuelve a intentar."), 5 * 60 * 1000);
    window.addEventListener("message", handleMessage);
    try {
      facebook.init({ appId, cookie: true, xfbml: false, version: graphVersion || "v25.0" });
      facebook.login((response) => {
        if (settled) return;
        code = String(response?.authResponse?.code || "").trim();
        if (!code) fail("La conexion de WhatsApp fue cancelada o no fue autorizada.");
        else finish();
      }, {
        config_id: configId,
        response_type: "code",
        override_default_response_type: true,
        extras: {
          setup: phone ? { business: { phone: { code: phone.code, number: phone.number } } } : {},
          featureType: "whatsapp_business_app_onboarding", sessionInfoVersion: "3", version: "v4",
        },
      });
    } catch {
      fail("No pudimos abrir Meta. Permite la ventana de conexion y vuelve a intentar.");
    }
  });
};
